/* global angular */
( function () {
	'use strict';

	/* eslint-disable max-params */
	function EditScheduleModal ( logger, $scope, $route, $modalInstance, eventModel, editschedservice, createschedservice, SCHEDULE_MESSAGES, createObsService, $q ) {
		/* eslint-enable max-params */
		var self = this;

		self.title        = 'Edit Schedule';
		self.inviteeTitle = SCHEDULE_MESSAGES.invitee;

		// defaults
		self.selections            = [ ];
		self.schedule              = angular.copy( eventModel );
		self.schedule.eventDate    = self.schedule.startDate;
		self.schedule.endDate      = self.schedule.endDate;
		self.schedule.startTime    = self.schedule.startDate;
		self.schedule.endTime      = self.schedule.endDate;
		self.schools               = [ ];
		self.observees             = [ ];
		self.templates             = [ ];
		self.templateRemoved       = false;
		self.isEventHidden         = self.schedule.isHidden || false;
		self.message               = SCHEDULE_MESSAGES;
		self.schedule.inviteesInfo = [ ];

		function validateEventDate ( $event ) {
			var dateRegex = /^(0[0-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/([0-9]\d{1})$/;

			self.invalidDateFormat = !dateRegex.test( $event.currentTarget.value );
			self.invalidDate       = createschedservice.invalidDate( $event.currentTarget.value );
		}

		function openCalendarPicker ( dateType ) {
			if ( dateType === 'start' ) {
				self.isOpenCalendar = !self.isOpenCalendar;
			} else {
				self.isOpenCalendarEnd = !self.isOpenCalendarEnd;
			}
		}

		function disableDatesHandler ( date, mode ) {
			return createschedservice.disableDates( date, mode );
		}

		function incorrectTimeHandler () {
			var pastTime      = createschedservice.incorrectTime( self.schedule.eventDate, self.schedule.startTime );
			var incorrectTime = createschedservice.incorrectTime( self.schedule.eventDate, self.schedule.startTime, self.schedule.endTime );

			return pastTime || incorrectTime || editschedservice.incorrectEndTime( self.schedule );
		}

		function incorrectEndTime () {
			return editschedservice.incorrectEndTime( self.schedule ) || createschedservice.incorrectTime( self.schedule.eventDate, self.schedule.startTime, self.schedule.endTime );
		}

		function closeModal () {
			$modalInstance.close();
		}

		function removeObservee ( inviteeInfo ) {
			var inviteesInfo = [ ];

			self.schedule.meta.invitees.splice( self.schedule.meta.invitees.indexOf( inviteeInfo.PersonnelId ), 1 );
			self.schedule.inviteesInfo.map( function ( invitee ) {
				if ( invitee.PersonnelId !== inviteeInfo.PersonnelId ) {
					inviteesInfo.push( invitee );
				}
			} );
			self.schedule.inviteesInfo = inviteesInfo;
			$scope.$broadcast( 'removeObservee', inviteeInfo );
		}

		function getLocationAndObservees ( schools, observeeId ) {
			var location = editschedservice.getLocation( schools,  observeeId );

			if ( location ) {
				self.schedule.locationId = location.ID;
				self.locationMarker      = location.SchoolName;
				self.observees           = location.users;
			}
		}

		function getInviteeName ( inviteeId ) {
			var observee = editschedservice.getObservee( self.schools, inviteeId );
			var invitee  = {
				'ClientId'    : editschedservice.getSessionCredentials().ClientId,
				'PersonnelId' : editschedservice.getSessionCredentials().PersonnelId,
				'name'        : editschedservice.getSessionCredentials().FirstName + ' ' + editschedservice.getSessionCredentials().LastName
			};

			if ( editschedservice.getSessionCredentials().userId !== inviteeId ) {
				invitee = {
					'ClientId'    : observee.ClientId,
					'PersonnelId' : observee.PersonnelId,
					'name'        : observee.FirstName + ' ' + observee.LastName
				};
			}

			self.schedule.inviteesInfo.push( invitee );
		}

		function inInvitees ( id ) {
			return self.schedule.meta.invitees.some( function ( invitee ) {
				return invitee === id;
			} );
		}

		function getObserveeName ( schools, observeeId ) {
			var observee = editschedservice.getObservee( schools,  observeeId );

			if ( observee ) {
				self.observeeMarker             = observee.FirstName + ' ' + observee.LastName;
				self.schedule.observeeClientId  = observee.ClientId;
				self.schedule.observeeFirstName = observee.FirstName;
				self.schedule.observeeLastName  = observee.LastName;
			}
		}

		function getTemplateName ( templates, templateId ) {
			var template = editschedservice.getTemplate( templates,  templateId );

			if ( template ) {
				self.templateMarker    = template.name;
				self.schedule.template = template;
				self.selectTemplate    = template;
			}
		}

		function removeSelectedObservee ( selections ) {
			var location = editschedservice.getSelectedByPointer( selections, 'SchoolName' );

			if ( location.length && ( self.schedule.locationId !== location[ 0 ].data.ID )  ) {
				self.schedule.locationId    = location[ 0 ].data.ID;
				self.observees              = location[ 0 ].data.users;
				self.schedule.meta.invitees = [ ];
				self.schedule.inviteesInfo  = [ ];
				self.schedule.observeeId    = '';
				self.observeeMarker         = 'Select a Teacher';
			}
		}

		function getSelectedObserveeId ( selections ) {
			var observee = editschedservice.getSelectedByPointer( selections, 'FirstName' );

			if ( observee.length ) {
				self.schedule.observeeId        = observee[ 0 ].data.PersonnelId;
				self.schedule.observeeClientId  = observee[ 0 ].data.ClientId;
				self.schedule.observeeFirstName = observee[ 0 ].data.FirstName;
				self.schedule.observeeLastName  = observee[ 0 ].data.LastName;
			}

			if ( observee.length && self.schedule.status === 'Meeting' && !inInvitees( observee[ 0 ].data.PersonnelId ) ) {
				self.schedule.meta.invitees.push( observee[ 0 ].data.PersonnelId );
				self.schedule.inviteesInfo.push( {
					'ClientId'    : observee[ 0 ].data.ClientId,
					'PersonnelId' : observee[ 0 ].data.PersonnelId,
					'name'        : observee[ 0 ].data.FirstName + ' ' + observee[ 0 ].data.LastName
				} );
			}
		}

		function getSelectedTemplateId ( selections ) {
			var template = editschedservice.getSelectedByPointer( selections, 'name' );

			if ( template.length ) {
				self.schedule.template     = template[ 0 ].data;
				self.schedule.templateId   = template[ 0 ].data.id;
				self.schedule.templateName = template[ 0 ].data.name;
			}
		}

		function removeTemplate () {
			self.schedule.templateId = '';
			self.templateMarker      = 'Select a Template';
			self.templateRemoved     = true;

			var selectedTemplate = self.selections.filter( function ( selection ) {
				return selection.pointer === 'name';
			} );

			var index = self.selections.indexOf( selectedTemplate );

			self.selections.splice( index, 1 );
		}

		function selectEmptyStrings ( key ) {
			var attrib = this.obj[ key ];

			return ( typeof attrib === 'string' ) && attrib.length === 0;
		}

		function removeEmptyAttributes ( key ) {
			delete this.obj[ key ];
		}

		function trimEmptyAttributes ( obj ) {
			var bindObj = { 'obj' : obj };

			angular
				.copy( Object.keys( obj ).filter( selectEmptyStrings.bind( bindObj ) ) )
				.map( removeEmptyAttributes.bind( bindObj ) );
		}

		function trimLocationDescription ( obj ) {
			trimEmptyAttributes( obj.meta || {} );

			return obj;
		}

		function saveChanges ( form, isInProgress ) {
			var endTimeInvalid = editschedservice.incorrectEndTime( self.schedule );

			if ( form.$valid && ( !incorrectTimeHandler() && !isInProgress ) || ( isInProgress && !endTimeInvalid ) ) {
				self.displayMsgToUser       = true;
				self.schedule.isEventHidden = self.isEventHidden;

				editschedservice.saveScheduleChanges( trimLocationDescription( self.schedule ) )
					.then( function () {
						self.scheduleSuccess = true;

						logger.notifySuccess( 'Successfully saved.', 'Event' );

						$modalInstance.close();
						$route.reload();
					}, function () {
						logger.notifyError( 'An error occurred. Please try again.', 'Event' );

						self.scheduleSuccess = false;
					} )
					.finally( function () {
						$modalInstance.close();
					} );
			}
		}

		function isLoaded ( fetchCount ) {
			if ( fetchCount === 2 ) {
				self.isFetching = false;

				if ( self.errData.length ) {
					self.isSuccess = false;
				}
			}
		}

		function activate () {
			self.isFetching          = true;
			self.isSuccess           = true;
			self.errData             = [];
			self.schedule.templateId = self.schedule.meta.templateId || '';
			var fetchCount           = 0;

			logger.info( 'Activated Edit Schedule Modal View' );

			self.schoolMarker   = 'Fetching School...';
			self.observeeMarker = 'Fetching Observation...';
			self.templateMarker = 'Fetching Template...';

			createObsService.getPreLoadedData().then( function ( q ) {
				$q.all( [ q[ 0 ].$promise, q[ 1 ].$promise ] )
				.then( function ( res ) {
					if ( res.length ) {
						self.templateMarker = 'Select a Template';

						self.templates = createObsService.getReorderedTemplates( res[ 0 ], res[ 1 ] );

						getTemplateName( self.templates, self.schedule.meta.templateId );

						if ( !self.schedule.template ) {
							self.removeTemplate();
						}
					}
				}, function () {
					self.errData.push( 'Unable to fetch templates.' );
				} ).finally( function () {
					fetchCount = fetchCount + 1;
					isLoaded( fetchCount );
				} );

				q[ 2 ].$promise.then( function ( districts ) {
					self.locationMarker = 'Pick a Location';
					self.observeeMarker = 'Select a Teacher';

					var schools = [];

					// look into all districts
					( districts || [] ).map( function ( district ) {
						schools = schools.concat( district.Schools || [] );
					} );

					self.schools = schools;

					if ( self.schedule.status === 'Meeting' ) {
						getLocationAndObservees( self.schools, self.schedule.meta.invitees[ 0 ] );
						self.schedule.meta.invitees.map( getInviteeName );
					} else {
						getLocationAndObservees( self.schools, self.schedule.meta.observee[ 0 ] );
						self.schedule.observeeId = self.schedule.meta.observee[ 0 ];
						getObserveeName( self.schools, self.schedule.meta.observee[ 0 ] );
					}
				}, function () {
					self.errData.push( 'Unable to fetch locations.' );
				} ).finally( function () {
					fetchCount = fetchCount + 1;
					isLoaded( fetchCount );
				} );
			} );

			// watcher to update scheduled event details
			$scope.$watch( function () {
				return self.selections;
			}, function ( newVal ) {
				if ( newVal.length ) {
					getSelectedObserveeId( newVal );
					getSelectedTemplateId( newVal );
					removeSelectedObservee( newVal );
				}
			}, true );

			$scope.$watch( 'vm.schedule.templateName', function ( newVal ) {
				if ( newVal ) {
					self.templateMarker = self.schedule.templateName;
				}
			} );

			$scope.$watch( 'vm.inviteeMarker', function () {
				self.inviteeMarker = 'Select a Person(s)';
			} );
		}

		activate();

		// calendar picker options
		self.isOpenCalendar    = false;
		self.isOpenCalendarEnd = false;
		self.dateOptions    = {
			'formatYear'  : 'yyyy',
			'startingDay' : 0
		};

		// handlers
		self.isPastEventHandler   = editschedservice.isPastEvent;
		self.removeTemplate       = removeTemplate;
		self.openCalendarPicker   = openCalendarPicker;
		self.disableDatesHandler  = disableDatesHandler;
		self.incorrectTimeHandler = incorrectTimeHandler;
		self.saveChanges          = saveChanges;
		self.closeModal           = closeModal;
		self.removeObservee       = removeObservee;
		self.validateEventDate    = validateEventDate;
		self.eventOnGoing         = editschedservice.isOnGoing;
		self.incorrectEndTime     = incorrectEndTime;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'EditScheduleModal', EditScheduleModal );

	EditScheduleModal.$inject = [ 'logger', '$scope', '$route', '$modalInstance', 'eventModel', 'editschedservice', 'createschedservice', 'SCHEDULE_MESSAGES', 'createObsService', '$q' ];
} )( );
